let mappingArray = [{
    db: 'draft',
    display: 'Draft',
    displayI18n: 'status.draft',
    style: ''
}, {
    db: 'pendingReview',
    display: 'Waiting for Review',
    displayI18n: 'status.pendingReview',
    style: ''
}, {
    db: 'inReview',
    display: 'In Review',
    displayI18n: 'status.inReview',
    // displayI18n: {
    //     en: 'In review',
    //     'zh-CN': '审查中',
    //     'zh-TW': '審查中'
    // },
    style: ''
}, {
    db: 'reviewed',
    display: 'Pending Release',
    displayI18n: 'status.reviewed',
    // displayI18n: {
    //     en: 'Pending release',
    //     'zh-CN': '等候发布',
    //     'zh-TW': '等候發佈'
    // },
    style: ''
}, {
    db: 'waitingDeveloperPublish',
    display: 'Waiting Developer Publish',
    displayI18n: 'status.waitingDeveloperPublish',
    // displayI18n: {
    //     en: 'Waiting developer publish',
    //     'zh-CN': '等候开发者发布',
    //     'zh-TW': '等候開發者發佈'
    // },
    style: ''
}, {
    db: 'published',
    display: 'Ready for Sale',
    displayI18n: 'status.published',
    style: 'statusAppListSuccess'
}, {
    db: 'preOrder',
    display: 'Pre-Order Ready for Sale',
    displayI18n: 'status.preOrder',
    // displayI18n: {
    //     en: 'Pre-order ready for sale',
    //     'zh-CN': '预购贩售中',
    //     'zh-TW': '預購販售中'
    // },
    style: 'statusAppListSuccess'
}, {
    db: 'removed',
    display: 'Removed from Sale',
    displayI18n: 'status.removed',
    // displayI18n: {
    //     en: 'Removed from sale',
    //     'zh-CN': '已移除',
    //     'zh-TW': '已移除'
    // },
    style: 'statusAppListFail'
}, {
    db: 'rejected',
    display: 'Rejected',
    displayI18n: 'status.rejected',
    // displayI18n: {
    //     en: 'Rejected',
    //     'zh-CN': '已拒绝',
    //     'zh-TW': '已拒絕'
    // },
    style: 'statusAppListFail'
}, {
    db: 'unpublished',
    display: 'Developer Removed from Sale',
    displayI18n: 'status.unpublished',
    // displayI18n: {
    //     en: 'Developer removed from sale',
    //     'zh-CN': '开发者移除',
    //     'zh-TW': '開發者移除'
    // },
    style: 'statusAppListFail'
}, {
    db: 'developerRejected',
    display: 'Developer Rejected',
    displayI18n: 'status.developerRejected',
    // displayI18n: {
    //     en: 'Developer rejected',
    //     'zh-CN': '开发者拒绝',
    //     'zh-TW': '開發者拒絕'
    // },
    style: 'statusAppListFail'
}, {
    db: 'noti',
    display: 'Developer Rejected',
    displayI18n: 'noti'
},
{
    db: 'admin',
    displayI18n: 'userRoles.admin'
},
{
    db: 'analytics',
    displayI18n: 'userRoles.analytics'
},
{
    db: 'all',
    displayI18n: 'userRoles.all'
}
]

export { mappingArray }
